import useUser from '../../../contexts/hooks/useUser'
import { trpc } from '../../../modules/trpc'

export type BadgeHook = ReturnType<typeof useBadges>

export const useBadges = () => {
	const { user } = useUser()

	const { data: badges, isLoading: isBadgesLoading } =
		trpc.badges.getAllBadgesWithTiers.useQuery(undefined)

	const { data: tiers, isLoading: isTiersLoading } = trpc.badges.getAllTiers.useQuery(undefined)

	const { data: userBadges, isLoading: isUserBadgesLoading } = trpc.badges.getUserBadges.useQuery(
		{ userId: user?.id ?? 0 },
		{
			enabled: !!user,
		}
	)

	const parsedUserBadges = userBadges?.map(userBadge => ({
		...userBadge,
		lastEarnedAt: new Date(userBadge.lastEarnedAt),
		badge: {
			...userBadge.badge,
			createdAt: new Date(userBadge.badge.createdAt),
			tiers: userBadge.badge.tiers.map(tier => ({
				...tier,
				createdAt: new Date(tier.createdAt),
			})),
		},
		tier: {
			...userBadge.tier,
			createdAt: new Date(userBadge.tier.createdAt),
		},
	}))

	const parsedBadges = badges?.map(badge => ({
		...badge,
		createdAt: new Date(badge.createdAt),
		tiers:
			badge.tiers?.map(tier => ({
				...tier,
				createdAt: new Date(tier.createdAt),
			})) || [],
	}))

	const parsedTiers = tiers?.map(tier => ({
		...tier,
		createdAt: new Date(tier.createdAt),
	}))

	const isLoading = isBadgesLoading || isTiersLoading || isUserBadgesLoading

	return {
		badges: parsedBadges,
		tiers: parsedTiers,
		userBadges: parsedUserBadges,
		isLoading,
	}
}
